module.exports = __webpack_public_path__ + "img/unchecked.04038b9f.svg";